import { useEffect } from 'react'
import type { ITextFieldMainAction } from 'shared/ui/TextField'

type ITextFieldMaxLength = {
  limit: number
  onChange?: (active: boolean) => void
}

export const makeTextFieldLimit: (action: ITextFieldMaxLength) => ITextFieldMainAction = (
  action
) => {
  const useAction: ITextFieldMainAction = (control, children) => {
    useEffect(
      () => action.onChange?.((control.value?.length ?? 0) >= action.limit),
      [control.value, action.onChange]
    )

    useEffect(() => {
      const input = control.inputRef?.current

      if (!input) return

      input.setAttribute('maxlength', `${action.limit}`)

      return () => input.removeAttribute('maxlength')
    }, [action.limit, action.onChange])

    return children
  }

  return useAction
}
